import React from 'react'

export default function intro(props) {
  const {handleSubmit, handleChange, errors,disableButton} = props
  console.log(props)
  function renderError(errors) {
    if(errors) {
      return <p className="inputError">Invalid Email Address </p> 
    }
  }
  let classes = ""
  classes += (errors) ? "error" : "no-error"
  return (
    <>
    <section className="intro">
      <div className="header">
        <h2><span className="invisibles">Bras Early Access</span> </h2>
          <p>After two years and countless hours of obsessing over every little detail, we’ve finally made the most comfortable bra on the planet. Well more like six of them </p>
        <p>Early Access Sign Up is now closed. Shop Tommy John Bras <a href="//tommyjohn.com/pages/bras">here</a></p>
        <h3>#comfortsoon</h3>
      </div>
      <div className="form invisible">
        <form onSubmit={handleSubmit()}>
          <input type="email" name="email" className={classes} placeholder="Your Email Address" autoComplete="on" onChange={handleChange("email")} required/>
          {renderError(errors)}
          <input className="button red" type="submit" value="Sign Up for Early Access" onClick={handleSubmit()} disabled={disableButton}/>
        </form>
      </div>
    </section>
    </>
  )
}
